<ng-container *transloco="let t">
  @if (showFavoriteLabels()) {
    <pxc-favorite-labels [selectedLabels]="selectedLabels()" (labelPicked)="addLabel($event.display)" />
  }

  <tui-textfield data-testid="label-input" multi tuiTextfieldSize="m">
    <input
      maxlength="255"
      ngDefaultControl
      tuiInputChip
      [ngModel]="value()"
      [placeholder]="t('Ajoutez des mots clés')"
      (ngModelChange)="onLabelChange($event)" />
    <tui-input-chip *tuiItem appearance="outline-grayscale" />
    @if (autocomplete()) {
      <tui-data-list-wrapper
        *tuiDropdown
        [emptyContent]="emptyState"
        [items]="allLabels() | tuiHideSelected | tuiFilterByInput" />
    }
  </tui-textfield>

  <ng-template #emptyState>
    <p class="font-bold text-text-secondary">
      {{ t('Aucun résultat.') }}
      <span class="font-normal text-text-placeholder">{{ t('Appuyez sur entrée pour ajouter le mot clé.') }}</span>
    </p>
  </ng-template>
</ng-container>
